/* Copyright (c) 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useEffect } from "react";
import { useCustomer } from "~/context";
import { ROUTES } from "~/routing/routes";
import { useGetPlans } from "~/views/plans/hooks";
import { DataBox } from "../DataBox/DataBox";

export function PlansCard() {
  const { customer } = useCustomer();

  const { count, refetch } = useGetPlans({
    page: "1",
    limit: "1",
    basic: true,
  });

  useEffect(() => {
    refetch();
  }, [customer, refetch]);

  return (
    <DataBox
      icon="production"
      title="Plans"
      value={count}
      iconLink={ROUTES.plans.index}
    />
  );
}
